import {QuestionModelV3, GuessModelV1, DraftGuessModelV1} from '@albert-io/models';
import {Draft} from 'immer';
import type {UseBoundStore, StoreApi} from 'zustand';

interface CoreQuestionState {
  // Question data
  question: QuestionModelV3 | null;
  questionId: string | null;
  // Draft guess state
  draftId: string | null;
  lastSaveTime: number | null;
  // Guess info
  guess: GuessModelV1 | null;
  isSubmitted: boolean;
  correctAnswer: Record<string, string> | null;
}

interface CoreQuestionActions {
  addQuestionInfo: (question: QuestionModelV3, questionId: string) => void;
  addDraftGuessInfo: (draftGuess: DraftGuessModelV1) => void;
  addGuessInfo: (guess: GuessModelV1) => void;
}
export interface WordBankItem {
  id: string;
  value: string;
  placedInSlot: string | null; // null means it's in the skeleton/word bank
}
interface DropSlot {
  id: string;
  label?: string;
}
export interface ItemBankState extends CoreQuestionState {
  // Layout-specific state
  wordBank: WordBankItem[];
  dropSlots: DropSlot[];
  placements: Record<string, string>; // {slotId: optionId}
  //
  activeItemId: string | null;
  isDragging: boolean;
}

export interface ItemBankActions extends CoreQuestionActions {
  // Interaction actions
  setActiveItem: (itemId: string | null) => void;
  placeItemInSlot: (itemId: string, slotId: string) => void;
  removeItemFromSlot: (slotId: string) => void;
  setIsDragging: (isDragging: boolean) => void;

  // Draft guess actions
  buildGuessContent: () => Record<string, string>;

  // Computed helpers
  getItemInSlot: (slotId: string) => string | undefined;
  isSlotFilled: (slotId: string) => boolean;
  hasUserSelectedAnswer: () => boolean;
}

export const initialState: ItemBankState = {
  // question data
  question: null,
  questionId: null,
  // layout
  placements: {},
  wordBank: [],
  dropSlots: [],
  activeItemId: null,
  isDragging: false,
  // Draft guess state
  draftId: null,
  lastSaveTime: null,
  // guess info
  guess: null,
  isSubmitted: false,
  correctAnswer: null
};
export type FitbItemBankStore = ItemBankState & ItemBankActions;

export type SetState = SetStateWithImmer<FitbItemBankStore>; // replaces UseBoundStore<StoreApi<FitbItemBankStore>>['setState'];
export type GetState = UseBoundStore<StoreApi<FitbItemBankStore>>['getState'];

// Allows set State to be used with immer
export type SetStateWithImmer<T> = (
  nextState: T | Partial<T> | ((state: Draft<T>) => void),
  replace?: boolean,
  name?: string
) => void;
